import { render, staticRenderFns } from "./SettingPlanDetail.vue?vue&type=template&id=6ccf1a1c&scoped=true&"
import script from "./SettingPlanDetail.vue?vue&type=script&lang=js&"
export * from "./SettingPlanDetail.vue?vue&type=script&lang=js&"
import style0 from "./SettingPlanDetail.vue?vue&type=style&index=0&id=6ccf1a1c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccf1a1c",
  null
  
)

export default component.exports